// Reactの機能をインポートします。`useState`は状態管理に、`useEffect`はライフサイクルフックに使用します。
import React, { useState } from 'react';
// 多言語対応機能を提供するreact-i18nextライブラリからuseTranslationフックをインポートします。
import { useTranslation } from 'react-i18next';
// 別のコンポーネントをインポートします。これにはサイト選択、各種クエリ生成機能などが含まれます。
import SiteSelector from './SiteSelector';
import GoogleQuery from './query/GoogleQuery';
import YouTubeQuery from './query/YouTubeQuery';
import BingQuery from './query/BingQuery';
import AmazonQuery from './query/AmazonQuery';
import XQuery from './query/XQuery';
import CommandSelector from './CommandSelector';
import BuildArea from './BuildArea';
// react-dndはドラッグアンドドロップ機能を提供するライブラリで、ここではHTML5のバックエンドを使っています。
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { v4 as uuidv4 } from 'uuid';


// SearchCommandBuilderという新しいコンポーネントを定義します。
function SearchCommandBuilder() {
    // useStateフックを使用して、様々な状態をこのコンポーネント内で管理します。
    const [selectedSite, setSelectedSite] = useState('google'); // 選択されたサイトの状態を管理します。
    const [searchQuery, setSearchQuery] = useState(''); // 検索クエリ文字列の状態を管理します。
    const [commandList, setCommandList] = useState([]); // コマンドリストの状態を管理します。
    const { t } = useTranslation(); // 多言語対応のためのフックを設定します。

    // selectedSite の状態を更新し、コマンドリストを空にする関数を定義します。
    const handleSiteChange = (newSite) => {
        setSelectedSite(newSite); // サイト選択の状態を更新します。
        setCommandList([]); // コマンドリストを空にします。
    };




    // addCommand関数は、新しいコマンドをリストに追加します。
    const addCommand = (command, fieldType, value, readonly, placeholder) => {
        const newCommand = { command: command, fieldType: fieldType, value: value, readonly: readonly, id: uuidv4(), placeholder: placeholder };
        setCommandList(prevList => [...prevList, newCommand]); // 現在のリストに新しいコマンドを追加します。      
    };

    // search関数は、構築された検索クエリを用いて検索を行います。
    const search = () => {
        let url;

        // 選択されたサイトに応じて、対応するクエリ関数を使用してURLを生成します。
        if (selectedSite === 'google') {
            url = GoogleQuery(searchQuery, commandList);
        } else if (selectedSite === 'youtube') {
            url = YouTubeQuery(searchQuery, commandList);

        } else if (selectedSite === 'bing') {
            url = BingQuery(searchQuery, commandList);

        } else if (selectedSite === 'amazon') {
            url = AmazonQuery(searchQuery, commandList);
        } else if (selectedSite === 'x') {
            url = XQuery(searchQuery, commandList);
        }

        // URLが生成された場合は、新しいタブでそのURLを開きます。
        if (url) {
            window.open(url, '_blank');
        }
    };

    // コンポーネントのUI部分をレンダリングします。
    return (
        <div className='main'>
            <div className='nav'>
                <div className='logo'>
                    <h1 className='title'>{t('title')}</h1>
                    <div className='subtitle'>{t('description')}</div>
                </div>

                {/* サイト選択コンポーネントと検索ボタン */}
                <SiteSelector selectedSite={selectedSite} onSelect={handleSiteChange} />
                <button onClick={search} className=''><i className="fas fa-search"></i>{t('search')}</button>
            </div>
            <div className='content'>
                <div className='left'>
                    {/* コマンドエリアコンポーネント。ユーザーが入力や選択を行えます。 */}
                    <CommandSelector
                        selectedSite={selectedSite}
                        value={searchQuery}
                        commands={{}}
                        onChange={setSearchQuery}
                        onCommandChange={() => { }}
                        onAddCommand={addCommand}
                    />
                </div>
                <div className='right'>
                    {/* ドラッグアンドドロッププロバイダーを使用して、ビルドエリアを包みます。 */}
                    <DndProvider backend={HTML5Backend}>
                        {/* ビルドエリアコンポーネント。ユーザーがコマンドを配置し、検索クエリを構築できます。 */}
                        <BuildArea
                            commandList={commandList}
                            setCommandList={setCommandList}
                        />
                    </DndProvider>
                </div>
            </div>
        </div>
    );
}

// このファイルからSearchCommandBuilderコンポーネントをエクスポートします。
export default SearchCommandBuilder;
